export const APP_TITLE = 'MyJunea'
export const CLOSE_ANIMATION_DURATION_MS = 300
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? '/api/v2'
export const MAINTENANCE_MODE: boolean = import.meta.env.VITE_MAINTENANCE_MODE === 'true'
export const DEFAULT_PAGE_SIZE = 15
export const DEBOUNCE_MS = 300
export const STALE_TIME_SHORT = 60 * 1000
export const STALE_TIME_LONG = 5 * 60 * 1000
